import { IDocumentEditable } from "../IDocumentEditable";
import { SpecifiedUserHisItemApplicator } from "./SpecifiedUserHisItemApplicator";

/**
 * 文書編集中に指示医を選択ダイアログから選択したとき、文書内のすべての指示医オブジェクトを連動して変更させる
 */
export class OrderDoctorApplicator extends SpecifiedUserHisItemApplicator {
  constructor(document: IDocumentEditable) {
    super(document, "ORDER_DOCTOR");
  }
}
